module.exports = __webpack_public_path__ + "static/img/Jony-J.f9c554c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Jony-J.jpg
// module id = YUX8
// module chunks = 1